export const VISIBILITY_TYPES = {
  ADMIN_ONLY: 'Somente admin',
  INTERNAL: 'Interno (logado)',
  PUBLIC: 'Público (não implementado)',
};

export const getVisibilityTypeTranslation = (type) => {
  return VISIBILITY_TYPES[type] || type;
};

export const STATUS ={
  DRAFT: 'Rascunho',
  PUBLISHED: 'Publicado'
}

export const getStatusTranslation = (type) => {
  return STATUS[type] || type;
};
